import { init } from '@elastic/apm-rum';

init({
  active: true,
  serverUrl: '/api/apm',
  serviceName: 'portal-baufiNow',
  serviceVersion: window.env?.version ?? 'local',
  environment: window.env?.stage ?? 'dev',
});

import('./src/Application');
